var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZenFilled = function SvgZenFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.747 21.82c-4.773 0-7.622-1.291-7.622-3.456 0-2.756 4.624-3.038 6.933-3.067-1.802-.33-3.013-.961-3.033-2.155-.008-.462.179-.89.554-1.271.794-.808 2.392-1.33 4.182-1.636h-.032c-1.27 0-5.135 0-5.135-2.424 0-1.55 1.584-2.002 3.451-2.127-.807-.318-1.342-.924-1.342-1.634 0-1.049 1.168-1.87 2.659-1.87 1.49 0 2.659.821 2.659 1.87 0 .696-.514 1.292-1.295 1.615 2.516.13 6.053.764 6.053 2.549 0 .864-.747 1.374-2.05 1.666 1.982.019 6.146.238 6.146 2.719 0 .918-.648 3.054-6.654 3.055-.441 0-.882-.002-1.317-.007 3.35.552 6.407 1.724 6.407 3.336 0 1.045-1.174 1.788-3.589 2.272-1.825.365-4.302.566-6.975.566Z"
  })));
};
export default SvgZenFilled;